import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import globalStyles from './styles/globals';
import { QueryClientProvider } from 'config/react-query';

globalStyles();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
